import { createContext, useContext } from 'react';

export interface BillingContextValue {
  /** True once the server has refused a billing write with a plain 403 (no `billing.manage`). The server's 403 is
   * authoritative and the browser has no permission list, so the page learns this the same way every other page in
   * this app does — by acting and reading the answer — and then stays read-only for the rest of its lifetime. */
  readOnly: boolean;
  markReadOnly: () => void;
  /** False when the server has no billing provider configured (`503 BILLING_UNAVAILABLE`). */
  providerAvailable: boolean;
  /** Bumps whenever a billing action succeeded, so every section re-reads the server's answer. */
  refreshToken: number;
  /** Re-reads the subscription, the billing status and every list, and tells the shell's banner to refresh. */
  refresh: () => void;
}

const DEFAULT: BillingContextValue = {
  readOnly: false,
  markReadOnly: () => {},
  providerAvailable: true,
  refreshToken: 0,
  refresh: () => {},
};

export const BillingContext = createContext<BillingContextValue>(DEFAULT);

export function useBilling(): BillingContextValue {
  return useContext(BillingContext);
}
